import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Provider as Redux } from 'react-redux'
import Bugsnag from '@bugsnag/js'
import { StyleSheetManager } from 'styled-components'
import Router from './Router'
import { RootErrorFallback } from '../components/errorFallback'
import '../../common/i18n/i18n'
import App from './App'
import AppGate from './AppGate'
import withSuspendedTranslation from '../components/hoc/withSuspendedTranslation'
import { useEmojis } from '../hooks/useEmojis'

// there is also ErrorBoundary in Router.js that most likely catches majority of errors
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

// wrap all in Suspended translation so app is shown after translation files are already loaded
const SuspendedTranslation = withSuspendedTranslation(({ children }) => <>{children}</>)

// We needs such Root for vanilla hot reloading.
const Root = ({ store }) => {
  // Enable store in Playwright automated tests
  if (!!window && window.__E2E__ && process.env.SERVER_ENV === 'local') {
    window.__store__ = store
  }

  useEmojis()

  return (
    <ErrorBoundary FallbackComponent={RootErrorFallback}>
      <Redux store={store}>
        <AppGate>
          <SuspendedTranslation>
            <StyleSheetManager enableVendorPrefixes>
              <Router />
            </StyleSheetManager>
          </SuspendedTranslation>
        </AppGate>
      </Redux>
    </ErrorBoundary>
  )
}
Root.propTypes = {
  store: PropTypes.object.isRequired,
}

export default Root
